import React from "react";
import styled from "styled-components";
import PretendardText from "../../../component/atoms/text/pretendardText";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import moment from "moment";

const DatePicker = ({
  wrapperStyle,
  style,
  iconStyle,
  onClick,
  popupIsOpen,
  startDate,
  startDateHandler,
  endDate,
  endDateHandler,
  footerBtnHandler,
  isOnlyOneDate,
  dateType,
  date,
  dateHandler,
  isPopupRight,
}) => {
  // 오늘 날짜를 YYYY-MM-DD 형식으로 반환하는 함수
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // YYYY-MM-DD 형식으로 변환
  };

  // n일 전 날짜를 YYYY-MM-DD 형식으로 반환하는 함수
  const getDateBefore = (days) => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date.toISOString().split("T")[0];
  };

  // 일간 날짜 형식을 변환하는 함수
  const dayDateFormatter = (date) => {
    // 사용자가 선택한 날짜 형식 (예: "2024-10-31")을 moment로 변환
    const selectedMoment = moment(date, "YYYY-MM-DD", true);

    // 날짜 포맷 변환 (YYYY-MM-DD (요일) 형식으로 변환)
    const formattedDate = `${selectedMoment.format(
      "YYYY-MM-DD"
    )} (${getDayOfWeek(selectedMoment)})`;

    // 선택된 날짜를 설정
    dateHandler(formattedDate);
  };

  // 주간 날짜 형식을 변환하는 함수
  const weekDateFormatter = (date) => {
    // 사용자가 선택한 주차 형식 (예: "2024-W43")을 moment로 변환
    const selectedMoment = moment(date, "YYYY-[W]WW", true);

    // 주의 시작일 (월요일)과 끝일 (일요일)을 계산
    const startOfWeek = selectedMoment.clone().startOf("isoWeek");
    const endOfWeek = selectedMoment.clone().endOf("isoWeek");

    // 날짜 포맷 변환 (YYYY-MM-DD (요일) 형식으로 변환)
    const formattedStartDate = `${startOfWeek.format(
      "YYYY-MM-DD"
    )} (${getDayOfWeek(startOfWeek)})`;
    const formattedEndDate = `${endOfWeek.format("YYYY-MM-DD")} (${getDayOfWeek(
      endOfWeek
    )})`;

    // 선택된 날짜를 주의 시작일 ~ 끝일로 설정
    dateHandler(`${formattedStartDate} → ${formattedEndDate}`);
  };

  // 요일을 반환하는 함수
  const getDayOfWeek = (date) => {
    const days = ["일", "월", "화", "수", "목", "금", "토"];
    return days[date.day()];
  };

  return (
    <>
      {isOnlyOneDate && (
        <div
          style={{
            width: "fit-content",
            minWidth: "135px",
            position: "relative",
            zIndex: 1,
            ...wrapperStyle,
          }}
        >
          <DatePickerWrapper
            style={{
              ...style,
            }}
            onClick={onClick}
          >
            <img
              src="/assets/admin/icons/ico_celendar.svg"
              alt=""
              style={{
                width: 18,
                height: 18,
                pointerEvents: "none",
                ...iconStyle,
              }}
            />
            <InputWrapper
              required
              type={dateType ? dateType : "date"}
              // data-placeholder={"YYYY/MM/DD"}
              style={{
                ...style,
                width: "100%",
                opacity: 0,
                position: "absolute",
                left: 0,
              }}
              onChange={(e) => {
                if (dateType === "week") {
                  weekDateFormatter(e.target.value);
                }
                if (dateType === "date") {
                  dayDateFormatter(e.target.value);
                }
                if (dateType === "month") {
                  dateHandler(e.target.value);
                }
              }}
              value={date}
            />
            <DatePickerText>
              {date === "" && "YYYY/MM/DD"}
              {date !== "" && date}
            </DatePickerText>
          </DatePickerWrapper>
        </div>
      )}

      {!isOnlyOneDate && (
        <div
          style={{
            width: "338px",
            position: "relative",
            zIndex: 1,
            ...wrapperStyle,
          }}
        >
          <DatePickerWrapper
            style={{
              ...style,
            }}
            onClick={onClick}
          >
            <img
              src="/assets/admin/icons/ico_celendar.svg"
              alt=""
              style={{
                width: 18,
                height: 18,
                pointerEvents: "none",
                ...iconStyle,
              }}
            />
            <DatePickerText>
              {startDate === endDate && endDate !== "" && startDate}
              {startDate !== endDate &&
                endDate !== "" &&
                `${moment(startDate).format("YYYY-MM-DD")} (${moment(startDate)
                  .local()
                  .format("ddd")}) → ${moment(endDate).format(
                  "YYYY-MM-DD"
                )} (${moment(endDate).local().format("ddd")})`}
              {((startDate === "" && endDate === "") ||
                (startDate !== "" && endDate === "")) &&
                "YYYY/MM/DD"}
            </DatePickerText>
            {popupIsOpen && (
              <PopupContainer
                style={{
                  left: !isPopupRight && 0,
                  right: isPopupRight && 0,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "24px 31px 24px 30px",
                    borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  <PretendardText
                    style={{
                      fontWeight: "600",
                      fontSize: "20px",
                      lineHeight: "34px",
                      letterSpacing: "-0.3%",
                      color: "#f3f3f3",
                    }}
                  >
                    조회기간
                  </PretendardText>
                  <img
                    src="/assets/admin/icons/ico_popup_close.svg"
                    alt="팝업 닫기"
                    style={{
                      width: 30,
                      height: 30,
                      cursor: "pointer",
                    }}
                    onClick={onClick}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    padding: "20px 31px 40px 30px",
                    borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    gap: 12,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <GrayBtn
                      onClick={() => {
                        const today = getTodayDate();
                        startDateHandler(today);
                        endDateHandler(today);
                      }}
                    >
                      오늘
                    </GrayBtn>
                    <GrayBtn
                      onClick={() => {
                        const today = getTodayDate();
                        const oneWeekAgo = getDateBefore(7);
                        startDateHandler(oneWeekAgo);
                        endDateHandler(today);
                      }}
                    >
                      최근 1주일
                    </GrayBtn>
                    <GrayBtn
                      onClick={() => {
                        const today = getTodayDate();
                        const thirtyDaysAgo = getDateBefore(30);
                        startDateHandler(thirtyDaysAgo);
                        endDateHandler(today);
                      }}
                    >
                      최근 30일
                    </GrayBtn>
                  </div>
                  <DateInputWrapper>
                    <InputWrapper
                      required
                      type={"date"}
                      // data-placeholder={"YYYY/MM/DD"}
                      style={{
                        ...style,
                      }}
                      onChange={(e) => {
                        startDateHandler(e.target.value);
                      }}
                      value={startDate}
                    />
                    <span
                      style={{
                        width: 6,
                        height: 1,
                        backgroundColor: "rgba(181, 181, 181, 0.5)",
                      }}
                    />
                    <InputWrapper
                      required
                      type={"date"}
                      // data-placeholder={"YYYY/MM/DD"}
                      style={{
                        ...style,
                      }}
                      onChange={(e) => {
                        endDateHandler(e.target.value);
                      }}
                      value={endDate}
                    />
                  </DateInputWrapper>
                </div>
                <PopupFooter>
                  <PopupFooterBtn onClick={footerBtnHandler}>
                    <PopupFooterText>검색하기</PopupFooterText>
                  </PopupFooterBtn>
                </PopupFooter>
              </PopupContainer>
            )}
          </DatePickerWrapper>
        </div>
      )}
    </>
  );
};

export default DatePicker;

const DatePickerWrapper = styled.div.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  /* justify-content: center; */
  gap: 16px;
  background-color: #272829;
  border-radius: 23px;
  cursor: pointer;
`;

const DatePickerText = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.3%;
  color: #aaa;
`;

const PopupContainer = styled.div.attrs((props) => {})`
  position: absolute;
  top: 47px;
  width: 759px;
  height: fit-content;
  background-color: #272829;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  cursor: default;
`;

const DateInputWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const InputWrapper = styled.input.attrs((props) => {})`
  width: 338px;
  height: 48px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  background: inherit;
  padding: 13px 15px;
  color: #aaa;
  font-family: "Pretendard";
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;

  &:focus {
    outline: none !important;
    border-color: #27beff !important; /* 우선순위 강제 */
  }

  &::placeholder {
    color: rgba(181, 181, 181, 0.5);
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }

  &:disabled {
    border-color: #b8bfc4;
    color: #808991 !important;
    background: #80899133 !important;
  }
`;

const PopupFooter = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  padding: 16px 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const PopupFooterBtn = styled.button.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #272829;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 4px;
  &:hover {
    background-color: inherit;
    border: 1px solid rgba(255, 255, 255, 0.12);
  }
`;

const PopupFooterText = styled(PretendardText).attrs((props) => {})`
  font-weight: 600;
  font-size: 15px;
  line-height: 24.5px;
  color: #aaa;
`;
